import {KTIcon} from '../../../../../_metronic/helpers'
const UserNewModalHeader = ({
  selectedListingId,
  setSelectedListingId,
  listing,
  getListing,
  openAddModal,
  setOpenAddModal
}) => {
  
  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder listing_title'>Add New Property Editor/Guard for {listing.title}</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() =>  {
          setSelectedListingId()
          setOpenAddModal(false)
        }}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {UserNewModalHeader}
